__turbopack_context__.v({
  "link": "CLmsZa_link",
  "link--inline": "CLmsZa_link--inline",
  "link--lg": "CLmsZa_link--lg",
  "link--md": "CLmsZa_link--md",
  "link--sm": "CLmsZa_link--sm",
  "link__arrow": "CLmsZa_link__arrow",
});
